import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin, Tooltip } from 'antd'
import AddIngredient from './add'
import EditIngredient from './edit'
import DeleteIngredient from './delete'
import IngredientRibbon from './ribbon'
import ImportIngredient from './import'
import MyIcon from '../../components/general/icon'

export default function Ingredient() {
  const [ingredientData, setIngredientData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isAddIngredientVisible, setIsAddIngredientVisible] = useState(false)
  const [isEditIngredientVisible, setIsEditIngredientVisible] = useState(false)
  const [isDeleteIngredientVisible, setIsDeleteIngredientVisible] = useState(false)
  const [isImportIngredientVisible, setIsImportIngredientVisible] = useState(false)

  const initialConditions = {
    keywords: '',
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getIngredientData = () => {
    axios.post('/admin/content/basic_ingredient/list/get', { 
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setIngredientData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'ingredients': response.data.ingredients
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getIngredientData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, currentPage])

  const editIngredient = (oid) => {
    setIsEditIngredientVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteIngredient = (oid, name) => {
    setIsDeleteIngredientVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">运动食材</div>
            <IngredientRibbon
              filterValue={filterValue} 
              setFilterValue={setFilterValue}
              isImportVisible={() => { setIsImportIngredientVisible(true) }} 
              isAddVisible={() => { setIsAddIngredientVisible(true) }}  
            />
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th><div className='public-main-style2-title'>食材名称/100g</div></th>
                    <th>热量(kcal)</th>
                    <th>碳水化合物(g)</th>
                    <th>蛋白质(g)</th>
                    <th>脂肪(g)</th>
                    <th>水分(g)</th>
                    <th>钾(mg)</th>
                    <th>钠(mg)</th>
                    <th>钙(mg)</th>
                    <th>镁(mg)</th>
                    <th>铁(mg)</th>
                    <th>磷(mg)</th>
                    <th style={{width: '50px'}}></th>
                  </tr>
                </thead>

                <tbody>
                  {ingredientData.ingredients && (ingredientData.ingredients.length > 0 ? (ingredientData.ingredients.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editIngredient(item.oid) }}>
                      <td><div className='public-main-style2-title'>{item.name}</div></td>
                      <td>{item.calorie}</td>
                      <td>{item.carbohydrate}</td>
                      <td>{item.protein}</td>
                      <td>{item.fat}</td>
                      <td>{item.moisture}</td>
                      <td>{item.potassium}</td>
                      <td>{item.sodium}</td>
                      <td>{item.calcium}</td>
                      <td>{item.magnesium}</td>
                      <td>{item.iron}</td>
                      <td>{item.phosphorus}</td>
                      <td style={{width: '50px'}}>
                        <div className='public-main-style2-operation-box'>
                          <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                            <div className='public-main-style2-operation' 
                              onClick={(event) => {event.stopPropagation(); deleteIngredient(item.oid, item.name)}}>
                              <MyIcon name='huishouzhan' />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='12'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={ingredientData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>

        {isAddIngredientVisible && <AddIngredient
          getIngredientData={getIngredientData} 
          isOpen={isAddIngredientVisible} 
          isCancel={() => { setIsAddIngredientVisible(false) }} 
        />}

        {isEditIngredientVisible && <EditIngredient
          data={propsData}
          getIngredientData={getIngredientData} 
          isOpen={isEditIngredientVisible} 
          isCancel={() => { setIsEditIngredientVisible(false) }} 
        />}

        {isDeleteIngredientVisible && <DeleteIngredient
          data={propsData}
          getIngredientData={getIngredientData} 
          isOpen={isDeleteIngredientVisible} 
          isCancel={() => { setIsDeleteIngredientVisible(false) }} 
        />}

        {isImportIngredientVisible && <ImportIngredient
          getIngredientData={getIngredientData}
          isOpen={isImportIngredientVisible}
          isCancel={() => { setIsImportIngredientVisible(false) }}
        />}
      </Spin>
    </div>
  )
}
